import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { fromInvoices, fromOrder } from '../store';
import { AnalyticsCartSnapshot, buildPlanCartSnapshot } from '../utils/analytics';

export const usePlanCartSnapshot = (): AnalyticsCartSnapshot => {
  const productsPreview = useSelector(fromOrder.selectOrderProductsPreview);
  const terminatedInvoicePreviews = useSelector(fromInvoices.selectTerminatedPreviews);

  return useMemo(
    () => buildPlanCartSnapshot({
      productsPreview,
      terminatedInvoicePreviews,
    }),
    [productsPreview, terminatedInvoicePreviews],
  );
};
